<template>
  <div class="app-acesso" ref='acesso'>
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus="statusGeral" :cpntIcone="false" :cpntTamanho="5"></RF-Status>
    
    <!-- SETA OS DADOS DA PAGINA -->
    <template v-else>
       <!-- SETA AS MENSAGENS DE ERRO RECEBIDA NA ROTA -->
      <div class="erros" v-if="[ '', null, undefined ].indexOf(erros) === -1">
        <div>
          <span v-html="erros"></span>
        </div>
      </div>

      <!-- SETA O QUADRO DE LOGIN -->
      <div class="quadrado noselect" ref='quadrado'>
        <!-- SETA A LOGOTIPO DA CONTA -->
        <table class="logo">
          <!-- LOGO PADRÃO SEM CONTA SELECIONADA -->
          <tr v-if="[ '', null, undefined ].indexOf($route.params) !== -1 || [ '', null, undefined ].indexOf($route.params.logotipo) !== -1" class="padrao">
            <td>
              <img src='./img/logo_padrao.png' />
            </td>
          </tr>

          <!-- LOGO DA LICENÇA DE USO DO CLIENTE -->
          <tr v-else class="cliente">
            <td>
              <img :src="$route.params.logotipo" />
            </td>
            <td>
              <template v-if="[ '', null, undefined ].indexOf($route.params.licenca) === -1">
                <!-- APRESENTA O NOME DA EMPRESA -->
                <div v-html="$route.params.licenca.rSocial"></div>

                <!-- APRESENTA O CNPJ DA EMPRESA -->
                <div v-html="$route.params.licenca.cnpj"></div>
              </template>
            </td>
          </tr>
        </table>

        <!-- SETA OS CAMPOS DE CONTA E SENHA -->
        <div class="campos">
          <RF-Componente v-if="Object.keys(conta).length >= 1"
            :data-time='time'
            :cpntTamanho='conta.tamanho'
            :cpntModelo='conta.tipo'
            :cpntType='conta.type'
            :cpntStatus='conta.status'
            :cpntId='conta.id'
            :cpntClassDivField='conta.classDivField'
            :cpntNome='conta.nome'
            :cpntValue='conta.value'
            :cpntValueRef='conta.valueRef'
            :cpntOptions='conta.options'
            :cpntKeyValue='conta.keyValue'
            :cpntKeyMostra='conta.keyMostra'
            :cpntAutoComplete='conta.autocomplete'
            :cpntDisabled='conta.disabled === true || entrar.status !== ""'
            :cpntMostrar='conta.mostrar'
            :cpntMensagem='conta.mensagem'
            :cpntSelecioneNome='conta.selecioneNome'
            :cpntSelecioneValue='conta.selecioneValue'
            :cpntMensagemTipo='conta.mensagemTipo'
            :cpntAdicinarOption='conta.adicinarOption'
            :cpntMultiple='conta.multiple'
            :cpntAllRegistro='conta.allRegistro'
            :cpntExplica='conta.explica'
            :cpntConfig='conta.config'
            :cpntTabIndex='conta.tabIndex'
            :cpntMaxLength='conta.maxLength'
            :cpntOptionInicialNome='conta.optionInicialNome'
            :cpntOptionInicialValue='conta.optionInicialValue'

            :cpntOnKeyPressEnter='conta.onKeyPressEnter'
            :cpntOnChange='conta.onChange'
            :cpntOnBlur='conta.onBlur'
            ref='conta'
          ></RF-Componente>

          <RF-Componente v-if="Object.keys(senha).length >= 1"
            :data-time='time'
            :cpntTamanho='senha.tamanho'
            :cpntModelo='senha.tipo'
            :cpntType='senha.type'
            :cpntStatus='senha.status'
            :cpntId='senha.id'
            :cpntClassDivField='senha.classDivField'
            :cpntNome='senha.nome'
            :cpntValue='senha.value'
            :cpntValueRef='senha.valueRef'
            :cpntOptions='senha.options'
            :cpntKeyValue='senha.keyValue'
            :cpntKeyMostra='senha.keyMostra'
            :cpntAutoComplete='senha.autocomplete'
            :cpntDisabled='senha.disabled === true || entrar.status !== ""'
            :cpntMostrar='senha.mostrar'
            :cpntMensagem='senha.mensagem'
            :cpntSelecioneNome='senha.selecioneNome'
            :cpntSelecioneValue='senha.selecioneValue'
            :cpntMensagemTipo='senha.mensagemTipo'
            :cpntAdicinarOption='senha.adicinarOption'
            :cpntMultiple='senha.multiple'
            :cpntAllRegistro='senha.allRegistro'
            :cpntExplica='senha.explica'
            :cpntConfig='senha.config'
            :cpntTabIndex='senha.tabIndex'
            :cpntMaxLength='senha.maxLength'
            :cpntOptionInicialNome='senha.optionInicialNome'
            :cpntOptionInicialValue='senha.optionInicialValue'

            :cpntOnKeyPressEnter='senha.onKeyPressEnter'
            :cpntOnChange='senha.onChange'
            :cpntOnBlur='senha.onBlur'
            ref='senha'
          ></RF-Componente>
        </div>

        <div class="recaptcha">
          <div id="app-google-recaptcha" class="g-recaptcha"></div>
        </div>

        <div class="checkbox-salvar">
          <!-- SETA O NOME DO CAMPO -->
          <span v-html="checkbox.nome" class="noselect" @click="() => { checkbox.onChange(!checkbox.value, checkbox.id) }"></span>

          <!-- SETA O CHECKBOX -->
          <RF-Checkbox-Tabela
            :data-time='time' 
            :cpntStatus='checkbox.status'
            :cpntId='checkbox.id' 
            :cpntNome='""'
            :cpntValue='"salvar"'
            :cpntChecked='checkbox.value === true ? [ "salvar" ] : []'
            :cpntExplica='checkbox.explica'
            :cpntOnChange='checkbox.onChange'
          ></RF-Checkbox-Tabela>
        </div>

        <table class="adicionais">
          <!-- SETA O RECAPCHA DO LOGIN -->
          <!-- <tr>
            <td colspan="2">
              <div id="app-google-recaptcha" class="g-recaptcha"></div>
            </td>
          </tr> -->

          <tr>
            <!-- SETA A LOGO DO ROTINA FACIL -->
            <td class="logo">
              <a href='http://www.rotinafacil.com.br' target='_blank'><img src="/img/rotina_facil.png"></a>
            </td>

            <!-- SETA O BOTÃO ENTRAR -->
            <td class="botao">
              <RF-Button 
                :cpntId='entrar.id'
                :cpntStatus='entrar.status' 
                :cpntTexto='entrar.texto' 
                :cpntClass='entrar.class' 

                @onClickButton='entrar.onClick'
              ></RF-Button> 
            </td>
          </tr>
          <tr class="links">
            <!-- SETA O BOTÃO DE ESQUECEU A SENHA -->
            <td>
              <a @click="appAcessoEsqueciSenha">Esqueceu sua senha?</a>
            </td>

            <!-- SETA O BOTÃO CADASTRE-SE -->
            <td>
              <router-link :to="{ name: 'pag_setup' }" target='_parent'>Quero me cadastrar!</router-link>
            </td>
          </tr>
        </table>
      </div>

      <!-- SETA O BOTÃO PARA ACESSAR OUTRA CONTAS -->
      <template v-if="Object.keys($store.state.contas).filter(item => $store.state.contas[item].salvar === true).length >= 1">
        <router-link ref="BTOutrasContas" tag="button" class="btn btn-primary app-acesso-outras-contas" :to="{ name: 'con_exi', params: {} }" target='_parent'>Acessar outra conta</router-link>
      </template>

      <!-- SETA O BOTÃO PARA ENTRAR NA VERSÃO ANTIGA -->
      <!-- <router-link v-if="$store.state.mobile === false && ELECTRON === false" class="app-acesso-antigo" :to='{ name: "ver-antiga" }' tag='a'>Ir para a versão antiga</router-link> -->
    </template>
  </div>
</template>

<style scoped>
.app-acesso {
  text-align: center;
  overflow-x: auto;
}
  .app-acesso > .rf-status {
    margin-top: 213.5px
  }
  .app-acesso > .erros {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
    .app-acesso > .erros > div {
      color: #a94442;
      display: inline-block;
      background-color: #f2dede;
      border: 1px solid #cc939c;
      border-radius: 3px;

      -moz-box-shadow: #5a5a5a 2px 2px 4px;
      -webkit-box-shadow: #5a5a5a 2px 2px 4px;
      box-shadow: #5a5a5a 2px 2px 4px;
      padding: 5px 30px;
    }
  .app-acesso > .quadrado {
    background: #fff;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    width: 380px;
    max-width: 90%;
    min-height: 350px;
    margin: 15px auto;
    padding: 25px;
    border-radius: 10px;
  }
    .app-acesso > .quadrado > .logo {
      width: 100%;
    }
      .app-acesso > .quadrado > .logo > tr > td {
        text-align: center;
      }
        .app-acesso > .quadrado > .logo > tr.padrao > td > img {
          width: 100px;
          min-width: 100px;
          border-radius: 20px;
          width: 95px;
        }
      .app-acesso > .quadrado > .logo > tr.cliente > td {
        text-align: left;
        /* width: 1%; */
        width: calc(100% - 130px);
        white-space: pre-line;
      }
        .app-acesso > .quadrado > .logo > tr.cliente > td > img {
          width: 130px;
          padding-right: 10px;
        }
        .app-acesso > .quadrado > .logo > tr.cliente > td > div {
          font-size: var(--font-base-soma-13);
          line-height: 18px;
        }

    .app-acesso > .quadrado > .campos {
      margin-top: 40px;
    }
      .app-acesso > .quadrado > .campos > div {
        width: 100%;
        max-width: 100%;
      }
      .app-acesso > .quadrado > .campos > div:not(:last-child) {
        margin-bottom: 35px;
      }

    .app-acesso > .quadrado > .checkbox-salvar {
      text-align: right;
      margin-top: 15px;
    }
      .app-acesso > .quadrado > .checkbox-salvar > span {
        cursor: pointer;
      }

    .app-acesso > .quadrado > .adicionais {
      margin-top: 10px;
      width: 100%;
    }
      .app-acesso > .quadrado > .adicionais > tr > td {
        width: 50%;
        vertical-align: top;
      }
      .app-acesso > .quadrado > .adicionais > tr > .botao {
        padding-top: 10px;
        text-align: right;
      }
        .app-acesso > .quadrado > .adicionais > tr > .botao > button {
          width: 120px;
        }
      .app-acesso > .quadrado > .adicionais > tr > .logo {
        text-align: left;
      }
        .app-acesso > .quadrado > .adicionais > tr > .logo > a > img {
          width: 120px;
          height: auto;
        }

      .app-acesso > .quadrado > .adicionais > tr.links > td {
        text-align: center;
        padding-top: 30px;
      }
        .app-acesso > .quadrado > .adicionais > tr.links > td:first-child {
          text-align: left;
          padding-left: 10px;
        }
        .app-acesso > .quadrado > .adicionais > tr.links > td:last-child {
          text-align: right;
          padding-right: 2px;
        }
          .app-acesso > .quadrado > .adicionais > tr.links > td > a {
            font-size: 12px;
          }

  .app-acesso-outras-contas {
    margin: 10px 0px;
  }

  .app-acesso-antigo {
    position: fixed;
    right: 5px;
    bottom: 2px;
  }
</style>

<style>
  .app-acesso > .quadrado > .campos > div > div {
    width: 100% !important;
    max-width: 100% !important;
  }
    .app-acesso > .quadrado > .campos > div > div > input:disabled {
      background-color: #f5f5f5;
    }

  .app-acesso > .quadrado > .recaptcha > div {
    width: 280px;
    margin: 0px auto;
    margin-top: 10px;
    margin-bottom: -10px;
  }

  .app-acesso > .quadrado > .checkbox-salvar > span > label {
    margin-right: 0px !important;
  }
</style>

<script>
export default {
  components: {
    'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
  },
  data: function () {
    return {
      time: '',
      statusGeral: '',
      recapcha: null,
      ELECTRON: (window.ELECTRON === true || window.DESKTOP === true),
      tamanho: 34,
      erros: '',
      conta: {
        id: 'app-acesso--conta',
        tipo: 'input',
        nome: 'Conta',
        type: 'text',
        value: '',
        placeholder: 'usuário@código',
        onChange: this.appAcessoOnChangeValue,
        onKeyPressEnter: this.appAcessoOnKeyPressEnter
      },
      senha: {
        id: 'app-acesso--senha',
        tipo: 'input',
        nome: 'Senha',
        type: 'password',
        value: '',
        onChange: this.appAcessoOnChangeValue,
        onKeyPressEnter: this.appAcessoOnKeyPressEnter
      },
      checkbox: {
        id: 'app-acesso--checkbox',
        status: '',
        tipo: 'checkbox',
        nome: 'Salvar conta',
        value: true,
        selected: [ 'salvar' ],
        mostrar: false,
        explica: { mensagem: 'Marque esta opção caso deseje deixar salvo sua conta.' },
        onChange: this.appAcessoOnChangeValue
      },
      entrar: {
        status: '',
        id: 'app-acesso--entrar',
        texto: 'Entrar',
        class: [ 'btn', 'btn-primary', 'g-recaptcha' ],
        onClick: this.appAcessoRealizarLogin
      }
    }
  },
  mounted: function () {
    this.appAcessoIniciar()
  },
  methods: {
    appAcessoIniciar: function () {
      // REALIZA O PREENCHIMENTO NO VUEX DAS INFORMAÇOES
      this.$store.commit('SET_TOKEN', {})

      // // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
      // const FUN_MOSTRAR_SCROLL_BODY = require('@/assets/js/Funcoes-Gerais.js').FUN_MOSTRAR_SCROLL_BODY

      // // SETA SE DEVE ATIVAR O SROLL DO BODY OU NÃO
      // FUN_MOSTRAR_SCROLL_BODY(true)

      // VERIFICA SE FOI RECEBIDO ALGUMA CONTA
      if ([ '', null, undefined ].indexOf(this.$route.params) === -1 && [ '', null, undefined ].indexOf(this.$route.params.autoLogin) === -1) {
        // PEGA OS DADOS RECEBIDOS
        var login = this.$route.params.autoLogin

        // CONVERTE OS CARACTERES
        var arrayReplace = { '%21': '!', '%23': '#', '%24': '$', '%25': '%', '%26': '&', '%27': '\'', '%28': '(', '%29': ')', '%2A': '*', '%2B': '+', '%2F': '/', '%3A': ':', '%3C': '<', '%3D': '=', '%3E': '>', '%3F': '?', '%40': '@', '%5B': '[', '%5D': ']', '%5E': '^', '%60': '`', '%7B': '{', '%7C': '|', '%7D': '}', '%7E': '~' }

        // CONVERTE OS VALORES RECEBIDOS
        for (var replace in arrayReplace) {
          while (login.indexOf(replace) !== -1) {
            login = login.replace(replace, arrayReplace[replace])
          }
        }

        // DESCRIPTOGRAFA O VALOR RECEBIDO E CONVERTE O JSON EM OBJETO
        login = JSON.parse(this.$store.state.FUN_CRIPTOGRAFIA('dec', login, process.env.VUE_APP_C32_KEY))

        // SETA O NOME DA CONTA RECEBIDA
        this.conta.value = [ '', null, undefined ].indexOf(login.conta) === -1 ? login.conta : ''
        this.senha.value = [ '', null, undefined ].indexOf(login.senha) === -1 ? login.senha : ''
        this.checkbox.value = [ '', null, undefined ].indexOf(login.sessao) === -1 ? login.sessao : false

        // DESATIVA O CAMPO, POIS FOI PREENCHIDO AUTOMATICAMENTE
        this.conta.disabled = true
        this.senha.disabled = true
        this.checkbox.disabled = true

        // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
        setTimeout(() => { this.appCalcularTamanho() }, 100)

        // CHAMA A FUNÇÃO PARA REALIZAR O LOGIN
        this.appAcessoRealizarLogin()
      } else if ([ '', null, undefined ].indexOf(this.$route.params) === -1 && [ '', null, undefined ].indexOf(this.$route.params.conta) === -1) {
        // SETA O NOME DA CONTA RECEBIDA
        this.conta.value = [ '', null, undefined ].indexOf(this.$route.params.conta) === -1 ? this.$route.params.conta : ''
        this.checkbox.value = [ '', null, undefined ].indexOf(this.$route.params.salvar) === -1 ? this.$route.params.salvar : true

        // DESATIVA O CAMPO, POIS FOI PREENCHIDO AUTOMATICAMENTE
        this.conta.disabled = true

        // LIMPA O ERRO DO CAMPO
        this.erros = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE A CONTA ESTÁ CONECTADA E DEVE DAR FOCUS NO CAMPO
        if ([ '', null, undefined ].indexOf(this.$route.params.cts) === -1 && this.$route.params.conectado === true && [ '', null, undefined ].indexOf(this.$route.params.token) === -1) {
          // SETA O STATUS CARREGANDO DA PAGINA
          this.appAcessoStatusGeral('carregando')

          // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS
          this.$store.state.comunicaAPI('/acesso/check-token/get', 'GET', null, () => {  
            // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
            const SESSAO_USUARIO_INICIAR = require('@/assets/js/Sessao.js').SESSAO_USUARIO_INICIAR
  
            // CHAMA A FUNÇÃO PARA ENTRAR
            SESSAO_USUARIO_INICIAR(this.$route.params.cts).then(() => { this.$router.push({ name: 'pag_inicial', params: { cts: this.$route.params.cts } }) })
          }, this.appSolicitarLogin, null, this.$route.params.token)
        } else {
          this.appSolicitarLogin()
        }
      } else {
        // VERIFICA SE A CONTA ESTÁ CONECTADA E DEVE DAR FOCUS NO CAMPO
        if ([ '', null, undefined ].indexOf(this.conta.value) !== -1) {
          this.appAcessoFocus('conta')
        } else if ([ '', null, undefined ].indexOf(this.senha.value) !== -1) {
          this.appAcessoFocus('senha')
        }

        // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
        setTimeout(() => { this.appCalcularTamanho() }, 100)
      }
    },
    appSolicitarLogin: function (valido, cod, err) {
      // VERIFICA SE TEM ALGUM ERRO PARA COLOCAR NA TELA
      if ([ '', null, undefined ].indexOf(cod) === -1) {
        // SETA A MENSAGEM RECEBIDA
        this.erros = 'API [' + cod + ']: ' + err.message

        // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
        const SESSAO_LIMPAR_CONTA_ATUAL = require('@/assets/js/Sessao.js').SESSAO_LIMPAR_CONTA_ATUAL
  
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DA API
        SESSAO_LIMPAR_CONTA_ATUAL(this.$route.params.cts)
      }

      // SETA O STATUS CARREGANDO DA PAGINA
      this.appAcessoStatusGeral('')

      // DA O FOCUS NO CAMPO
      this.appAcessoFocus('senha')

      // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
      setTimeout(() => { this.appCalcularTamanho() }, 100)
    },
    appCalcularTamanho: function (repetir = 0) {
      if (this.tamanho !== null) {
        // SETA O TAMANHO INICIAL
        var tamanho = 0

        // SETA O TAMANHO QUADRADO
        tamanho += [ '', null, undefined ].indexOf(this.$refs.quadrado) === -1 ? this.$refs.quadrado.offsetHeight : 0

        // SETA O TAMANHO DO BOTÃO
        tamanho += [ '', null, undefined ].indexOf(this.$refs.BTOutrasContas) === -1 ? this.$refs.BTOutrasContas.$el.offsetHeight : 0

        // INICIA A O TAMANHO
        tamanho = ((this.$store.state.tamanhoTela.height - tamanho) / 2)
  
        // SETA A POSIÇÃO CALCULADA
        this.$refs.acesso.style = 'padding-top: ' + tamanho + 'px;'
  
        // VERIFICA SE DEVE PROCESSAR NOVAMENTE
        if ((tamanho - this.tamanho) > 5) {
          repetir = 0
        }
  
        // VERIFICA SE DEVE CALCULAR O TAMANHO
        if (repetir <= 2) {
          // SETA O TAMANHO ATUALIZADO
          this.tamanho = tamanho

          // CHAMA A FUNÇÃO PARA CALCULAR NOVAMENTE
          setTimeout(() => { this.appCalcularTamanho((repetir + 1)) }, 100)
        }
      }
    },
    appAcessoStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // SETA O STATUS DA PAGINA
      switch (this.statusGeral) {
        case 'carregando':
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])
          break

        default:
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])
          break
      }
    },
    appAcessoFocus: function (chave, tentativa = 0) {
      if (this.$store.state.mobile === false && tentativa <= 20) {
        if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].$refs.input) === -1) {
          this.$refs[chave].$refs.input.onFocusField()
        } else {
          setTimeout(() => { this.appAcessoFocus(chave, (tentativa + 1)) }, 100)
        }
      }
    },
    appAcessoOnChangeValue: function (value, id) {
      // PEGA O NOME DO CAMPO QUE SERÁ ATUALIZADO
      var index = id.split('--')[1]

      // SETA O VALOR RECEBIDO
      this[index].value = value

      // REMOVE A MENSAGEM DE ERRO
      this[index].mensagem = ''
      this[index].mensagemTipo = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    appAcessoEsqueciSenha: function () {
      // INICIA OS PARAMETROS
      var params = {}
      
      // VERIFICA SE A CONTA ESTA PREENCHIDA NO FORMULARIO
      if ([ '', null, undefined ].indexOf(this.conta.value) === -1) {
        params.conta = this.conta.value
      }

      // REDIRECIONA PARA PAGINA DE ACESSO
      this.$router.push({ name: 'esqueceu_senha', params: params })
    },
    appAcessoRealizarLogin: function () {
      if (this.recapcha === false) {
        // APRESENTA A MENSAGEM DE ERRO
        this.$store.commit('MSG_WARN', { origin: 'WEB', code: '406', message: 'Não foi possível realizar a validação de segurança. Tente novamente.' })

        // CHAMA FUNÇÃO PARA INICIAR O RECAPCHA
        this.appAcessoRecapchaIniciar()
      } else if (this.senha.value.indexOf('/acesso/') !== -1) {
        window.location = this.senha.value
      } else {
        // SETA O STATUS DO BUTTON
        this.entrar.status = 'carregando'
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { conta: this.conta.value, senha: this.senha.value, ect: (window.ELECTRON === true || window.DESKTOP === true) }
  
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/acesso', 'POST', formData, (apiSuccess) => {
          // SETA O STATUS CARREGANDO DA PAGINA
          this.appAcessoStatusGeral('carregando')
  
          // SETA OS DADOS QUE DEVEM SER SALVOS TAMBEM
          apiSuccess.data.conta = formData.conta
          apiSuccess.data.salvar = this.checkbox.value

          // QUEBRA A ATUALIZAÇÃO
          setTimeout(() => {
            // SETA OS DADOS DO CAMPO
            this.conta.value = formData.conta
    
            // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
            const SESSAO_LOGIN_SALVAR = require('@/assets/js/Sessao.js').SESSAO_LOGIN_SALVAR
    
            // CHAMA FUNÇÃO PARA SALVAR LOCALSTORAGE
            SESSAO_LOGIN_SALVAR(apiSuccess.data)
          }, 100)
        }, this.appAcessoStatusGeral, (apiValid, apiStatus) => {
          // APRESENTA AS MENSAGENS
          this.$store.state.FUN_API_RET_VALIDA(this, 'formulario', apiValid, apiStatus, {}, true)
          
          // CHAMA FUNÇÃO PARA INICIAR O RECAPCHA
          this.appAcessoRecapchaIniciar()

          // CHAMA A FUNÇÃO PARA DAR FOCUS
          this.appAcessoFocus('senha')
  
          // SETA O STATUS DO BUTTON
          this.entrar.status = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      }
    },
    appAcessoOnKeyPressEnter: function (id) {
      // PEGA O NOME DO CAMPO QUE SERÁ ATUALIZADO
      var index = id.split('--')[1]

      // VERIFICA A AÇÃO QUE DEVE SER FEITO
      switch (index) {
        // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO SENHA
        case 'conta':
          this.appAcessoFocus('senha')
          break

        // CHAMA A FUNÇÃO PARA REALIZAR O LOGIN
        case 'senha':
          this.appAcessoRealizarLogin()
          break
      }
    },
    appAcessoRecapchaIniciar: function () {
      // VERIFICA SE DEVE REINICIAR O RECAPTCHA OU INICIAR
      if (this.recapcha !== null) {
        // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
        window.grecaptcha.reset()

        // SETA O FLAG DO RECAPCHA
        this.recapcha = false

        // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
        setTimeout(() => { this.appCalcularTamanho() }, 100)
      } else {
        // SETA O FLAG DO RECAPCHA
        this.recapcha = false

        // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
        setTimeout(() => { this.appCalcularTamanho() }, 100)

        // INICIA O RECAPCHA
        window.grecaptcha.render('app-google-recaptcha', { sitekey: process.env.VUE_APP_GOO_SIT, callback: (response) => {
          // VERIFICA SE FOI RECEBIDO UMA RESPOSTA VALIDA
          this.recapcha = [ '', null, undefined ].indexOf(response) === -1
  
          // VERIFICA SE DEVE REALIZAR ALGUMA FUNÇÃO
          if (this.recapcha === true) {
            if ([ '', null, undefined ].indexOf(this.conta.value) !== -1) {
              this.appAcessoFocus('conta')
            } else if ([ '', null, undefined ].indexOf(this.senha.value) !== -1) {
              this.appAcessoFocus('senha')
            } else {
              this.appAcessoRealizarLogin()
            }
          }

          // CHAMA A FUNÇÃO PARA CALCUALR O TAMANHO E POSIÇÃO
          setTimeout(() => { this.appCalcularTamanho() }, 100)
        } })
      }
    }
  }
}
</script>
